import { attach } from 'services/tracking/attach';
import { tracking } from 'services/tracking/tracking';
import { GetRegion } from '../../../../constants';
import { browserHistory } from 'react-router';
import {
  DEVICE_ATTACH_INIT,
  DEVICE_ATTACH_SUCCESS,
  DEVICE_ATTACH_ERROR,
  TRACKING_INIT,
  TRACKING_SUCCESS,
  TRACKING_ERROR,
  CSS_VIDEO_MUST_FINISHED_ERROR_CODE,
  TICK_PATH,
  TIME_PATH,
} from './constants';
import getFirstNode from 'utils/getFirstNode';

export const attachdevice = (params = {}) => async dispatch => {
  try {
    dispatch({
      type: DEVICE_ATTACH_INIT,
    });
    const fetch = await attach(params);
    if (fetch.response) {
      dispatch({ type: DEVICE_ATTACH_SUCCESS, payload: fetch?.response });
    } else {
      dispatch({ type: DEVICE_ATTACH_ERROR, error: fetch?.errors?.[0]?.code });
    }
  } catch (e) {
    console.log('error===>', e);
    // dispatch({ type: DEVICE_ATTACH_ERROR, error: e });
  }
};
const redirectCSSErrorHelper = (url, response) => {
  if (url?.includes(TICK_PATH) || url?.includes(TIME_PATH)) {
    if (
      response.errors?.length &&
      response.errors[0].code === CSS_VIDEO_MUST_FINISHED_ERROR_CODE
    ) {
      document.getElementsByTagName('body')[0].style.cursor = '';

      const firstNode = getFirstNode();
      location.replace(`/${GetRegion()}/${firstNode}`);
    }
  }
};

export const trackingEvent = (url, params = {}) => async dispatch => {
  try {
    dispatch({
      type: TRACKING_INIT,
    });
    const fetch = await tracking(url, params);
    redirectCSSErrorHelper(url, fetch);
    if (fetch.response) {
      dispatch({ type: TRACKING_SUCCESS, payload: fetch?.response });
    } else {
      dispatch({ type: TRACKING_ERROR, error: fetch?.errors?.[0]?.code });
    }
  } catch (e) {
    console.log('error===>', e);
    // dispatch({ type: TRACKING_ERROR, error: e });
  }
};
